import {
    fetchAuthSession as ampFetchAuthSession,
    getCurrentUser as ampGetCurrentUser,
    signIn as ampSignIn,
    signInWithRedirect as ampSignInWithRedirect,
    signOut as ampSignOut,
    updatePassword as ampUpdatePassword,
} from 'aws-amplify/auth';

type AuthExports = {
    signIn: typeof ampSignIn;
    signOut: typeof ampSignOut;
    signInWithRedirect: typeof ampSignInWithRedirect;
    fetchAuthSession: typeof ampFetchAuthSession;
    updatePassword: typeof ampUpdatePassword;
    getCurrentUser: typeof ampGetCurrentUser;
};

const mockToken = {
    toString: () => 'mock-jwt-token',
};

const mockSession = {
    tokens: {
        accessToken: mockToken,
        idToken: mockToken,
    },
    credentials: undefined,
    identityId: undefined,
    userSub: undefined,
};

const mockAuth: AuthExports = {
    signIn: (() =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Promise.resolve({ isSignedIn: true, nextStep: { signInStep: 'DONE' } })) as any,

    signOut: () => Promise.resolve(),

    signInWithRedirect: () => Promise.resolve(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fetchAuthSession: (() => Promise.resolve(mockSession)) as any,

    updatePassword: () => Promise.resolve(),

    getCurrentUser: () => Promise.resolve({ username: 'mock-user', userId: 'mock-id' }),
};

// Whether or not the authentication should use the AWS authentication, or a mock implementation
const shouldMockAuth =
    (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') &&
    process.env.REACT_APP_MOCK_API === 'true';

const auth: AuthExports = shouldMockAuth
    ? mockAuth
    : {
          signIn: ampSignIn,
          signOut: ampSignOut,
          signInWithRedirect: ampSignInWithRedirect,
          fetchAuthSession: ampFetchAuthSession,
          updatePassword: ampUpdatePassword,
          getCurrentUser: ampGetCurrentUser,
      };

export const {
    signIn,
    signOut,
    signInWithRedirect,
    fetchAuthSession,
    updatePassword,
    getCurrentUser,
} = auth;
